// Do not modify this file by hand!
// Re-generate this file by running lit-localize.

/**
 * The locale code that templates in this source code are written in.
 */
export const sourceLocale = `en`;

/**
 * The other locale codes that this application is localized into. Sorted
 * lexicographically.
 */
export const targetLocales = [
  `cs`,
  `de`,
  `el`,
  `es`,
  `fr`,
  `it`,
  `nl`,
  `pl`,
  `ru`,
  `sr`,
  `tr`,
  `uk`,
  `zh`,
  `zh-CN`,
] as const;

/**
 * All valid project locale codes. Sorted lexicographically.
 */
export const allLocales = [
  `cs`,
  `de`,
  `el`,
  `en`,
  `es`,
  `fr`,
  `it`,
  `nl`,
  `pl`,
  `ru`,
  `sr`,
  `tr`,
  `uk`,
  `zh`,
  `zh-CN`,
] as const;
